import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody34';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy34 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Master Developer Partnership </h2><h4>Proposal for a Master Developer based out of KSA </h4>";

  return (
    <>
        <Helmet>
        <title>Master Developer Partnership Proposal for a Master Developer based out of KSA</title>
        <meta property="og:title" content="Master Developer Partnership Proposal for a Master Developer based out of KSA" />
        <meta property='og:description' content='Master Developer Partnership Proposal for a Master Developer based out of KSA'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy34" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy34
